import { render, staticRenderFns } from "./CustomerImportLocationDropdown.vue?vue&type=template&id=4d903ae8&scoped=true"
import script from "./CustomerImportLocationDropdown.vue?vue&type=script&lang=js"
export * from "./CustomerImportLocationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d903ae8",
  null
  
)

export default component.exports